let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7s1Qm")).then(() => parcelRequire('73mZu'));